import apiClient from "@/services/apiClient";

export async function getNotifications({ page = 1 } = {}) {
  const { data } = await apiClient.get("/backend/dashboard/notifications", {
    params: { page },
  });
  return data;
}

export async function getUnreadCount() {
  const { data } = await apiClient.get("/backend/dashboard/notifications/unread-count");
  return data;
}

export async function markNotificationRead(id) {
  const { data } = await apiClient.post(`/backend/dashboard/notifications/${id}/read`);
  return data;
}

export async function markAllNotificationsRead() {
  const { data } = await apiClient.post("/backend/dashboard/notifications/read-all");
  return data;
}

export async function deleteNotification(id) {
  const { data } = await apiClient.delete(`/backend/dashboard/notifications/${id}`);
  return data;
}
